var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x94\x84\xEB\xA1\x9C\xED\x95\x84\xEC\x82\xAC\xEC\xA7\x84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\xED\x94\x84\xEB\xA1\x9C\xED\x95\x84 \xEC\x82\xAC\xEC\xA7\x84 \xEB\xB2\x84\xED\x8A\xBC",
    x: 0.833984,
    y: 0.626709,
    width: 123.291,
    height: 123.291,
    rx: 61.6455,
    fill: "#04DB8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB0\xA4\xEB\x9F\xAC\xEB\xA6\xAC \xEB\xB2\x84\xED\x8A\xBC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.7748 39.9451H42.1809C38.818 39.9451 36.0918 42.6712 36.0918 46.0342V78.5093C36.0918 81.8722 38.818 84.5984 42.1809 84.5984H82.7748C86.1377 84.5984 88.8639 81.8722 88.8639 78.5093V46.0342C88.8639 42.6712 86.1377 39.9451 82.7748 39.9451Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72.6277 56.183C74.8697 56.183 76.6871 54.3655 76.6871 52.1236C76.6871 49.8817 74.8697 48.0642 72.6277 48.0642C70.3858 48.0642 68.5684 49.8817 68.5684 52.1236C68.5684 54.3655 70.3858 56.183 72.6277 56.183Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M68.5669 72.3942L57.0662 60.915C56.3343 60.1833 55.3507 59.7588 54.3163 59.7281C53.2819 59.6974 52.2749 60.063 51.501 60.7501L36.0918 74.4505M58.4184 84.599L74.0649 68.9526C74.7804 68.2356 75.7382 67.812 76.75 67.7651C77.7619 67.7181 78.7548 68.0512 79.5336 68.6988L88.8639 76.4802",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/프로필사진.415461eeb82e88b22165b7ef55cab423.svg";
export { ForwardRef as ReactComponent };